export function noop(..._: unknown[]) {
  return;
}

export async function noopAsync(..._: unknown[]) {
  return;
}
